import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import dict from '../dictionary';
import ReducedData from '../reducedData.json';
import { AnomalyNote } from './anomalies/AnomalyNote';
import {
  labelStyle,
  legend,
  responsiveFun,
  lineXaxis,
  getColours,
  anomalyColour,
  anomalyToolTip,
} from './options';
import trans from '../translations.json';
import { datesOfDeathAnomalies } from './anomalies/anomaliesList';
import { DownloadButton } from './options';
import StackedTable from './deathsDaily-table';
import { ButtonGroup } from './buttonGroup/buttonGroup';
import { getAnomalyIndex } from './utils';

const viewModes = {
  graph: 'graph',
  table: 'table',
};

const colourPalette = getColours(['death', 'anomaly']);
let anomalyIndex;

class DeathsDaily extends Component {
  state = {
    ready: false,
    series: [],
    options: {},
    selectedViewMode: viewModes.graph,
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lang !== this.props.lang) {
      this.setData();
    }
  }

  setData = () => {
    const lang = this.props.lang;

    var covidData = ReducedData.covidData;
    const cData = [...covidData];
    const chartData = cData.filter((item) => item[dict.deaths] > 0);

    var casesTotal = chartData.map((item) => {
      return item[dict.totaCases];
    });

    var dailydata = chartData
      .map((item, z) => {
        if (chartData[z - 1]) {
          return [
            item[dict.reportedDate],
            item[dict.deaths] - chartData[z - 1][dict.deaths],
          ];
        }
        return null;
      })
      .filter((item) => item);

    // Start date is generally March 18th, 2020
    const firstDate = new Date(dailydata[0][0]);
    anomalyIndex = getAnomalyIndex(firstDate, datesOfDeathAnomalies);

    this.setState({
      casesTotal: casesTotal,

      series: [
        {
          name: trans.deathsDaily.deaths[lang],
          data: dailydata,
        },
      ],
      plotOptions: {
        bar: {
          // horizontal: true,
          dataLabels: {
            //position: "top",
          },
        },
      },
      options: {
        legend: legend,
        // tooltip: tooltip,
        tooltip: {
          followCursor: true,
          style: { ...labelStyle },
          custom: function ({ series, dataPointIndex, w }) {
            return anomalyToolTip(
              series,
              dataPointIndex,
              w,
              anomalyIndex,
              lang,
              [trans.deathsDaily.deaths[lang]],
              colourPalette,
            );
          },
        },

        dataLabels: {
          enabled: false,
        },
        //stroke: stroke,
        responsive: responsiveFun().map((item) => {
          item.options.xaxis = { ...lineXaxis(true) };
          item.options.yaxis.title.text =
            trans.deathsDaily.yaxis[lang];
          return item;
        }),
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          zoom: { enabled: true },
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(lang, this.props.chartTitle),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        yaxis: {
          title: {
            text: trans.deathsDaily.yaxis[lang],
          },
          labels: {
            style: { ...labelStyle },
          },
        },
        xaxis: { ...lineXaxis(true) },
        // colors: colourPalette,
        colors: [
          function ({ value, dataPointIndex, seriesIndex, w }) {
            return anomalyColour(
              value,
              dataPointIndex,
              anomalyIndex,
              colourPalette,
              seriesIndex,
              w,
            );
          },
        ], //markers: markers,
      },
      ready: true,
    });
  };

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <div>
              <ReactApexChart
                options={this.state.options}
                series={this.state.series}
                type="bar"
                height="400px"
                aria-hidden="true"
              />
              <AnomalyNote lang={this.props.lang} />
            </div>
          );
        case viewModes.table:
          return <StackedTable lang={this.props.lang} />;
        default:
          break;
      }
    };

    return (
      <div id="">
        <p>{trans.deathsDaily.desc[this.props.lang]}</p>
        {this.state.ready && (
          <>
            <ButtonGroup
              selected={this.state.selectedViewMode}
              viewModes={viewModes}
              lang={this.props.lang}
              handleOnClick={this.onViewModeChange}
            />

            <GetRightView />
          </>
        )}
      </div>
    );
  }
}
export default DeathsDaily;
